import React from 'react';
import styled from 'styled-components';
import { ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import { Button } from '@monolith/components/0-atoms/Button';
import OpusModal from '@monolith/components/0-atoms/OpusModal';
import { STAFF_IMPORT_PAGE_COPY } from '../constants/staffImport';
import { staffImportTokens } from '../styles/staffImportTokens';

export interface StaffImportConfirmModalProps {
    isOpen: boolean;
    processing: boolean;
    staffCount: number;
    onClose: () => void;
    onConfirm: () => Promise<void> | void;
}

const MessageBody = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

const Message = styled.p`
    margin: 0;
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    line-height: 20px;
    color: #212121;
`;

const FooterActions = styled(ModalFooter)`
    display: flex;
    justify-content: flex-end;
    gap: ${staffImportTokens.spacing.sectionGap}px;
`;

const CancelButton = styled(Button)`
    color: ${staffImportTokens.colors.destructive};
`;

export const StaffImportConfirmModal: React.FC<
    StaffImportConfirmModalProps
> = ({ isOpen, processing, staffCount, onClose, onConfirm }) => {
    const handleConfirm = async () => {
        await onConfirm();
    };

    return (
        <OpusModal
            centered
            isOpen={isOpen}
            toggle={processing ? undefined : onClose}
            modalName="staff-import-confirm"
            wrapClassName="modal-primary modal-fit-content"
        >
            <ModalHeader toggle={processing ? undefined : onClose}>
                {STAFF_IMPORT_PAGE_COPY.confirmModalTitle(staffCount)}
            </ModalHeader>
            <ModalBody>
                <MessageBody>
                    <Message>
                        {STAFF_IMPORT_PAGE_COPY.confirmModalIntro(staffCount)}
                    </Message>
                    <Message>
                        {STAFF_IMPORT_PAGE_COPY.confirmModalUndoNote}
                    </Message>
                    <Message>
                        {STAFF_IMPORT_PAGE_COPY.confirmModalConfirmPrompt}
                    </Message>
                </MessageBody>
            </ModalBody>
            <FooterActions>
                <CancelButton
                    id="staff-import-confirm-cancel"
                    variant="text-only"
                    size="small"
                    onClick={onClose}
                    disabled={processing}
                >
                    {STAFF_IMPORT_PAGE_COPY.cancelLabel}
                </CancelButton>
                <Button
                    id="staff-import-confirm-import"
                    variant="primary"
                    size="small"
                    onClick={handleConfirm}
                    loading={processing}
                    disabled={processing}
                >
                    {STAFF_IMPORT_PAGE_COPY.confirmImportLabel}
                </Button>
            </FooterActions>
        </OpusModal>
    );
};

export default StaffImportConfirmModal;
